import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './style.scss';

export const StatisticsSquareSmall = ({ icon, count, text }) => {
  const { t } = useTranslation();

  return (
    <div className="statistics-square-small">
      <div className="block-square-icon">
        <div className="square-icon">
          <img src={icon} alt="icon" />
        </div>
      </div>

      <div className="statistics-square-count">
        <span className="number">{count}</span>
      </div>

      <div className="statistics-square-text">
        <p>{t(text)}</p>
      </div>
    </div>
  );
};
